import { Component, inject, Inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SafeMethod } from '../../../../shared/decorators/safe-method.decorator';
import { TranslateService } from '@ngx-translate/core';
import { SearchStateService } from '../../../shared/services/search-state.service';
import { MCAppGatewayService } from '../../../../shared/services/mcappgateway/mcappgateway.service';
import { PostGetLocationDetailsRequest } from '../../../../shared/model/providerlocationsearch/PostGetLocationDetailRequest';

@Component({
  selector: 'app-provider-search-details-location-card-mobile',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './provider-search-details-location-card.component.html',
  styleUrl: './provider-search-details-location-card.component.css'
})
export class ProviderSearchDetailsLocationCardComponent {
  searchState = inject(SearchStateService);
  mcAppGateway = inject(MCAppGatewayService);

  @Input() location!: any;
  @Input() canViewDetails: boolean = true;
  @Input() queryCityOrZip!: any;


  locale = "en-US";
  getDirectionsLabel = "Get directions";
  milesAwayLabel = "mi away";
  viewDetailsBtnText = "View details";

  constructor(private translate: TranslateService) {
    this.locale = sessionStorage.getItem('locale') || 'en-US';
    this.translate.use(this.locale);
  }

  ngOnInit() {
    this.translate.get('GET_DIRECTIONS').subscribe(translated => {
      this.getDirectionsLabel = translated;
    });

    this.translate.get('MILES_AWAY').subscribe(translated => {
      this.milesAwayLabel= translated
    });

    this.translate.get('VIEW_DETAILS').subscribe(translated => {
      this.viewDetailsBtnText = translated;
    });

  }
 
  @SafeMethod()
  onGetDirections(): void {
    if (this.location && this.location.locationDirection) {
      console.log('Opening directions:', this.location.locationDirection);
      window.open(this.location.locationDirection, '_blank');
    } else {
      console.error('No directions available for this location');
    }
  }

  @SafeMethod()
  onViewLocationDetails(): void {
    if(!this.canViewDetails) {
      console.log("4th level, cannot view details")
      return;
    }
    // Navigate to location details page (to be implemented)
    console.log('View details for location:', this.location?.practiceName);
    // TODO: Implement navigation to location details if needed


    if(this.location && this.location.locationId) {
      window.scrollTo({ top: 0, behavior: 'smooth' });

      var request = new PostGetLocationDetailsRequest();
      request.locationID = this.location.locationId;
      request.cityOrZip = this.queryCityOrZip;

      this.mcAppGateway.PostGetLocationDetails(request).subscribe(response => {
        console.log("Provider Location Details: ", response )
        this.searchState.setCurrentProviderDetailsLocation(response);
      });
    }

    

    // this.searchState.setCurrentProviderLocation()
    
  }

  @SafeMethod()
  onCallPhone(): void {
    if (this.location && this.location.phone) {
      const phoneNumber = this.location.phone.replace(/\D/g, ''); // Remove non-numeric characters
      console.log('Calling phone number:', phoneNumber);
      window.location.href = `tel:${phoneNumber}`;
    } else {
      console.error('No phone number available for this location');
    }
  }

  @SafeMethod('')
  getDistanceText(): string {
    if (this.location && this.location.distanceInMiles !== null && this.location.distanceInMiles !== undefined) {
      const distance = parseFloat(this.location.distanceInMiles);
      
      return `${distance.toFixed(1) + this.milesAwayLabel} `;
    }
    return '';
  }

  @SafeMethod('')
  getFullAddress(): string {
    if (!this.location) return '';
    
    const parts = [
      this.location.address1,
      this.location.address2,
      `${this.location.city}, ${this.location.state} ${this.location.zipCode}`
    ].filter(part => part);
    
    return parts.join(', ');
  }

  @SafeMethod(false)
  hasPhone(): boolean {
    return !!(this.location && this.location.phone);
  }

  @SafeMethod(false)
  hasDirections(): boolean {
    return !!(this.location && this.location.locationDirection);
  }

  @SafeMethod(false)
  hasDistance(): boolean {
    return this.location && this.location.distanceInMiles !== null && this.location.distanceInMiles !== undefined;
  }

  @SafeMethod(['Unknown Location'])
  getLocationNameLines(): string[] {
    const locationName = this.location?.locationName || 'Unknown Location';
    const prefix = 'MemorialCare Medical Group - ';
    
    if (locationName.startsWith(prefix)) {
      const remainingText = locationName.substring(prefix.length);
      if (remainingText.length > 7) {
        return [prefix.trim(), remainingText];
      }
    }
    
    return [locationName];
  }
}
